module.exports = __webpack_public_path__ + "04_long_gold.bbf9f21b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_long_gold.png
// module id = uggn
// module chunks = 0